/**
 * Loading indicator component showing progress status.
 */

import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import type { ProgressMessage, ThinkItemMessage } from '@app/api/carApi.manual';
import { MessageType } from '@app/api/carApi.manual';

export interface ChatLoadingIndicatorProps {
  isLoading: boolean;
  progressUpdate: ProgressMessage | null;
  lastThinkItem: ThinkItemMessage | null;
  isProgressConnected: boolean;
}

export const ChatLoadingIndicator: React.FC<ChatLoadingIndicatorProps> = ({
  isLoading,
  progressUpdate,
  lastThinkItem,
  isProgressConnected,
}) => {
  if (!isLoading) {
    return null;
  }

  const thinkItem = progressUpdate?.type === MessageType.THINK_ITEM
    ? (progressUpdate as ThinkItemMessage)
    : lastThinkItem;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CircularProgress size={16} />
        <Typography variant="par01Regular" color="text.secondary">
          {thinkItem?.title || (isProgressConnected ? 'Processing...' : 'Thinking...')}
        </Typography>
      </Box>
      {thinkItem?.description && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ ml: 3, fontStyle: 'italic' }}
        >
          {thinkItem.description}
        </Typography>
      )}
    </Box>
  );
};

